/**
 * Folder name validation utility
 *
 * Shared validation logic for folder names used across create and rename modals.
 *
 * @param {string} name - Folder name to validate
 * @param {Function} t - Translation function from i18next
 * @returns {string|null} Error message if invalid, null if valid
 */
export function validateFolderName(name, t) {
  const trimmedName = name.trim();

  if (!trimmedName) {
    return t('files.folders.nameRequired', 'El nombre de la carpeta es obligatorio');
  }

  if (trimmedName.length > 255) {
    return t('files.explorer.folderNameTooLong', 'El nombre es demasiado largo (máximo 255 caracteres)');
  }

  // Only allow alphanumeric, spaces, hyphens, and underscores
  if (!/^[a-zA-Z0-9\s\-_]+$/.test(trimmedName)) {
    return t('files.explorer.folderNameInvalid', 'Solo se permiten letras, números, espacios, guiones y guiones bajos');
  }

  return null;
}
